import { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import FlipbookMain from "../src/pages/FlipbookMain";
import GenAIFlipbookMain from "../src/pages/GenAIFlipbookMain";
import Footer from "./function-components/Footer";
import SearchNav from "./function-components/Searchnav";
import { PageLayout } from "./function-components/PageLayout";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const basename =
    window.location.hostname === "stagingapps1.lttlx.accenture.com"
      ? "/sapflipbook"
      : "/";
  return (
    <>
      <Router basename={basename}>
        <Switch>
          <Route exact path="/Home">
            <FlipbookMain />
          </Route>
          <Route exact path="/">
            <FlipbookMain />
          </Route>
          <Route exact path="/GenAI123">
            <GenAIFlipbookMain />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}
export default App;
